export default __webpack_public_path__ + "7269d4fd8373cc4a64a41fc49eb06c6a.png";